import React from 'react';
import { PropTypes } from 'prop-types';
import { useScreenSmDown, useScreenMinMd } from '@hooks/useResponsive';

const getIconDesktop = isActive => {
    const fill = isActive ? '#246EFF' : '#D3D0D5';
    const stroke = isActive ? '#fff' : '#000';

    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="19.6923" cy="19.7499" r="19.6923" fill={fill} />
            <g clipPath="url(#clip0_4747_52612)">
                <path d="M24.3809 23.4382L27.6669 26.7242" stroke="black" strokeMiterlimit="10" />
                <path
                    d="M20.328 18.5491L21.8 19.6577C22.136 19.9097 22.3333 20.3044 22.3333 20.7244V21.3911H17V20.7244C17 20.3044 17.1973 19.9097 17.5333 19.6577L19.0053 18.5491"
                    stroke={stroke}
                    strokeMiterlimit="10"
                />
                <path
                    d="M19.6673 18.7242C18.9307 18.7242 18.334 18.1275 18.334 17.3909V16.7242C18.334 15.9875 18.9307 15.3909 19.6673 15.3909C20.404 15.3909 21.0007 15.9875 21.0007 16.7242V17.3909C21.0007 18.1275 20.404 18.7242 19.6673 18.7242Z"
                    stroke={stroke}
                    strokeMiterlimit="10"
                    strokeLinecap="square"
                />
                <path
                    d="M19.6667 25.3909C23.3486 25.3909 26.3333 22.4062 26.3333 18.7243C26.3333 15.0424 23.3486 12.0576 19.6667 12.0576C15.9848 12.0576 13 15.0424 13 18.7243C13 22.4062 15.9848 25.3909 19.6667 25.3909Z"
                    stroke={stroke}
                    strokeMiterlimit="10"
                    strokeLinecap="square"
                />
            </g>
            <defs>
                <clipPath id="clip0_4747_52612">
                    <rect width="16" height="16" fill="white" transform="translate(12 11.0576)" />
                </clipPath>
            </defs>
        </svg>
    );
};

const getIconMobile = isActive => {
    const stroke = isActive ? '#246EFF' : '#1A1A1A';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <g fill="none" fillRule="evenodd" stroke={stroke} transform="translate(1 1)">
                <line x1="9.584" x2="12" y1="9.584" y2="12" />
                <path d="M6.26836364,5.58381818 L7.47272727,6.49090909 C7.74763636,6.69709091 7.90909091,7.02 7.90909091,7.36363636 L7.90909091,7.90909091 L3.54545455,7.90909091 L3.54545455,7.36363636 C3.54545455,7.02 3.70690909,6.69709091 3.98181818,6.49090909 L5.18618182,5.58381818" />
                <path
                    strokeLinecap="square"
                    d="M5.72727273,5.72727273 L5.72727273,5.72727273 C5.12454545,5.72727273 4.63636364,5.23909091 4.63636364,4.63636364 L4.63636364,4.09090909 C4.63636364,3.48818182 5.12454545,3 5.72727273,3 L5.72727273,3 C6.33,3 6.81818182,3.48818182 6.81818182,4.09090909 L6.81818182,4.63636364 C6.81818182,5.23909091 6.33,5.72727273 5.72727273,5.72727273 Z"
                />
                <circle cx="5.727" cy="5.727" r="5.455" strokeLinecap="square" />
            </g>
        </svg>
    );
};

const MenuMemberDirectory = ({ isActive = false }) => {
    const isScreenSmDown = useScreenSmDown();
    const isScreenMinMd = useScreenMinMd();

    return (
        <>
            {isScreenSmDown && getIconMobile(isActive)}
            {isScreenMinMd && getIconDesktop(isActive)}
        </>
    );
};

MenuMemberDirectory.propTypes = {
    isActive: PropTypes.bool,
};

export default MenuMemberDirectory;
